import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { BfPanel, BfModal, BfButton, BfDialog, BfTextInput, BfAnimatedFill } from 'components/Butterfly';
import UserList from 'src/components/account/UserList/UserList.vue';
import InvitationList from 'src/components/account/UserList/InvitationList.vue';
import { Form, Field } from 'src/components/forms';
import 'src/components/forms/rules/required';
import 'src/components/forms/rules/validDomain';
import FormModal from 'src/components/forms/FormModal.vue';
import store from 'src/store';
import { CLEAR_ERRORS, FETCH_APPROVED_DOMAINS, ADD_APPROVED_DOMAIN, REMOVE_APPROVED_DOMAIN, LOAD_SUBSCRIPTION, } from 'src/store/types';
import FormatUtils from 'src/utils/formatters';
export default Vue.extend({
    components: {
        FormModal,
        Form,
        Field,
        BfPanel,
        BfButton,
        BfDialog,
        BfTextInput,
        BfModal,
        BfAnimatedFill,
        UserList,
        InvitationList,
    },
    beforeRouteEnter(to, from, next) {
        store.dispatch({ type: CLEAR_ERRORS });
        try {
            next(vm => {
                vm.FETCH_APPROVED_DOMAINS();
            });
        }
        catch {
            next(false);
        }
    },
    data() {
        return {
            showing_add_ad_modal: false,
            showing_del_ad_modal: false,
            initialFormValues: {
                email_domain: '',
            },
            approved_domain_id_to_del: null,
            'response': undefined,
            showInviteModal: false,
            subscriptionLoading: false,
        };
    },
    computed: {
        ...mapGetters([
            'domain', 'userLimit', 'viewerUserLimit', 'membershipCount', 'viewerMembershipCount',
            'currentSite', 'approved_domains', 'approved_domains_loading',
            'currentUser',
        ]),
        approved_domain_to_be_deleted() {
            const domain = this.approved_domains.find((ad => ad.id === this.approved_domain_id_to_del));
            return domain ? domain.domain : '';
        },
        formattedUserLimit() {
            if (this.userLimit === Infinity) {
                return `${this.membershipCount} creator/admin users`;
            }
            else if (this.userLimit === this.membershipCount) {
                return `This site has no free seats for admin or creator users: (${this.membershipCount}/${this.userLimit} used).`;
            }
            else if (this.userLimit < this.membershipCount) {
                return `This site has too many admin and creator users: (${this.membershipCount}/${this.userLimit} used)`;
            }
            return `${this.userLimit - this.membershipCount} out of ${this.userLimit} creator or admin seats remaining.`;
        },
        formattedViewerUserLimit() {
            if (this.viewerUserLimit === undefined) {
                return '';
            }
            else if (this.viewerUserLimit === Infinity) {
                return `${this.viewerMembershipCount} explorer users.`;
            }
            else if (this.viewerUserLimit === this.viewerMembershipCount) {
                return `This site has no free seats for explorer users: (${this.viewerMembershipCount}/${this.viewerUserLimit} used).`;
            }
            else if (this.viewerUserLimit < this.viewerMembershipCount) {
                return `This site has too many explorer users: (${this.membershipCount}/${this.userLimit} used)`;
            }
            return `${this.viewerUserLimit - this.viewerMembershipCount} out of ${this.viewerUserLimit} explorer seats remaining.`;
        },
    },
    metaInfo() {
        return {
            title: this.currentSite ? `${this.currentSite.site_name} Users - Kapiche` : null
        };
    },
    methods: {
        ...mapActions({
            FETCH_APPROVED_DOMAINS,
            ADD_APPROVED_DOMAIN,
            REMOVE_APPROVED_DOMAIN,
            LOAD_SUBSCRIPTION,
        }),
        date: FormatUtils.date,
        async loadSubscription() {
            this.subscriptionLoading = true;
            try {
                this.LOAD_SUBSCRIPTION();
            }
            finally {
                this.subscriptionLoading = false;
            }
        },
        show_del_ad_modal(domainId) {
            this.approved_domain_id_to_del = domainId;
            this.showing_del_ad_modal = true;
        },
        cancel_del_new_domain() {
            this.showing_del_ad_modal = false;
        },
        del_approved_domain() {
            this.REMOVE_APPROVED_DOMAIN(this.approved_domain_id_to_del);
            this.showing_del_ad_modal = false;
            const ad = this.approved_domains.find(ad => ad.id === this.approved_domain_id_to_del);
            this.$analytics.track.site.removeApprovedDomain(ad.domain);
        },
        show_adding_new_domain() {
            this.showing_add_ad_modal = true;
        },
        cancel_adding_new_domain() {
            this.showing_add_ad_modal = false;
        },
        add_new_approved_domain({ email_domain }) {
            const ad = email_domain.trim();
            this.ADD_APPROVED_DOMAIN(ad);
            this.showing_add_ad_modal = false;
            this.$analytics.track.site.addApprovedDomain(ad);
        },
    }
});
